import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'

import { AddIncidentConfig } from '../../configuration'

export const addIncidentConfig: AddIncidentConfig<VolleyballIncidentId> = {
  scoreIncidents: [
    VolleyballIncidentId.ServiceAce,
    VolleyballIncidentId.AttackPoint,
    VolleyballIncidentId.BlockPoint,
    VolleyballIncidentId.Point,
    VolleyballIncidentId.SetWon,
  ],
  missedIncidents: [
    VolleyballIncidentId.ServiceError,
    VolleyballIncidentId.AttackError,
    VolleyballIncidentId.TechnicalErrors,
  ],
}
